module.exports = __webpack_public_path__ + "static/media/Playgrounds.305483a9.jpg";